import { useEffect, useState } from "react";
import { SOUNDS } from "@/lib/sounds";

// Gift box opening animation: box shakes → lid pops → gift rises → whole thing minimizes down
export const GiftBox = ({ event, side = "customer" }) => {
  const [phase, setPhase] = useState(null);
  useEffect(() => {
    if (!event) return undefined;
    setPhase("shake");
    const t1 = setTimeout(() => { setPhase("open"); SOUNDS.giftUnlock(); }, 700);
    const t2 = setTimeout(() => setPhase("minimize"), 2300);
    const t3 = setTimeout(() => setPhase(null), 3000);
    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); };
  }, [event]);
  if (!event || !phase) return null;
  return (
    <div data-testid="gift-box-modal" className={`fixed inset-0 z-[80] flex items-center justify-center pointer-events-none ${phase === "minimize" ? "gift-minimize" : ""}`}>
      <div className={`absolute inset-0 bg-black/40 transition-opacity duration-500 ${phase === "minimize" ? "opacity-0" : "opacity-100"}`} />
      <div className="relative flex flex-col items-center">
        {phase === "open" && <div className="absolute -top-16 gift-rise text-6xl">{event.gift?.emoji}</div>}
        <div className={`relative ${phase === "shake" ? "gift-shake" : ""}`}>
          <div className={`w-28 h-8 rounded-t-xl bg-gradient-to-b from-pink-400 to-pink-600 border-b-4 border-pink-800 relative z-10 ${phase !== "shake" ? "gift-lid" : ""}`}><div className="absolute left-1/2 -translate-x-1/2 -top-4 w-8 h-6 rounded-full border-4 border-yellow-300" /></div>
          <div className="w-28 h-24 rounded-b-xl bg-gradient-to-b from-fuchsia-500 to-purple-700 relative"><div className="absolute left-1/2 -translate-x-1/2 top-0 w-5 h-full bg-yellow-300/90" /></div>
        </div>
        <p className="mt-4 text-white font-bold text-sm drop-shadow">{phase === "shake" ? "ഗിഫ്റ്റ് ബോക്സ് തുറക്കുന്നു..." : `🎉 ${side === "staff" ? `${event.from_name} ${event.gift?.name} അയച്ചു!` : event.title || "Virtual Gift Unlocked!"}`}</p>
      </div>
    </div>
  );
};
